import React from 'react'
import styled from 'styled-components'
import { ModalButton } from 'src/components/Global/Button/Button'
import { Link, useLocation } from 'react-router-dom'
const ConfirmWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 83vh;
  padding-top: 43px;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  h2 {
    font-family: ${({ theme }) => theme.fontFamily.visuelt};
    font-weight: 500;
    font-size: ${({ theme }) => theme.fontSize.x1};
    color: ${({ theme }) => theme.colors.dark};
    line-height: 31px;
    text-transform: capitalize;
  }
  .blue {
    color: ${({ theme }) => theme.colors.CollaboBlue};
  }
  h3 {
    font-size: ${({ theme }) => theme.fontSize.x2};
    line-height: 24px;
    color: ${({ theme }) => theme.colors.dark};
    opacity: 0.8;
    font-weight: 500;
  }
  .bold {
    font-weight: 700;
  }
  .line {
    height: 3px;
    width: auto;
    background: ${({ theme }) => theme.colors.grey};
    margin: 0px -47px;
  }
  .confirm {
    margin: 30px 0px;
  }
  .cancel {
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.CollaboBlue};
    border: 1px solid ${({ theme }) => theme.colors.CollaboBlue};
  }
`
const ConfirmQuickSaveMasterCard = () => {
  let location = useLocation()
  return (
    <ConfirmWrapper>
      <div>
        <h2>
          Confirm Quicksave with <span className="blue">Mastercard</span>
        </h2>
        <h3>
          Please confirm that you are about to quicksave{' '}
          <span className="bold">₦ 15,000.00</span> with your Mastercard
          selected.
        </h3>
      </div>
      <div>
        <div className="line"></div>
        <Link to={`/success`} state={{ backgroundLocation: location }}>
          <ModalButton className="confirm">Confirm</ModalButton>
        </Link>
        <Link to={`/failed`} state={{ backgroundLocation: location }}>
          <ModalButton className="cancel">Cancel</ModalButton>
        </Link>
      </div>
    </ConfirmWrapper>
  )
}
const ConfirmQuickSaveVisaCard = () => {
  let location = useLocation()
  return (
    <ConfirmWrapper>
      <div>
        <h2>
          Confirm Quicksave with <span className="blue">Visacard</span>
        </h2>
        <h3>
          Please confirm that you are about to quicksave{' '}
          <span className="bold">₦ 15,000.00</span> with your Mastercard
          selected.
        </h3>
      </div>
      <div>
        <div className="line"></div>
        <Link to={`/success`} state={{ backgroundLocation: location }}>
          <ModalButton className="confirm">Confirm</ModalButton>
        </Link>
        <Link to={`/failed`} state={{ backgroundLocation: location }}>
          <ModalButton className="cancel">Cancel</ModalButton>
        </Link>
      </div>
    </ConfirmWrapper>
  )
}
export { ConfirmQuickSaveMasterCard, ConfirmQuickSaveVisaCard }
